export default "__VITE_ASSET__CupRTCNe__"